import React from 'react';
import MonthlyPerformanceTable from './MonthlyPerformanceTable';
import { TimePeriod } from '../../types/api';

interface ClubParametersTableProps {
  branchId?: number;
  currency?: string;
  timeRange?: TimePeriod;
}

const ClubParametersTable: React.FC<ClubParametersTableProps> = ({ branchId, currency, timeRange }) => {
  return (
    <MonthlyPerformanceTable
      branchId={branchId}
      currency={currency}
      timeRange={timeRange}
      dashboardSource="club"
      title="پارامترهای باشگاه مشتریان"
      guideKey="clubCustomerPerformanceTable"
      visibleColumns={[
        'month',
        'subscription',
        'invoiceCount', 
        'totalAmount',
        'creditInvoiceAmount',       
        'creditInvoiceCount',
        'creditPercent',
        'usedCredit',
        'creditUsedPercent',
        'uniqueCustomers'
        
        
      ]}
    />
  );
};

export default ClubParametersTable;
